/**
 * Leaf context module for the chronology Refine-with-Arc drawer.
 *
 * EntryRefinementCard (rendered via ChatMessage.TOOL_CARDS) needs the
 * drawer's apply handler; putting the context in its own leaf module keeps
 * the import chain acyclic (ChatMessage → EntryRefinementCard → here;
 * ChronologyRefineDrawer → here) — see the circular-imports-in-context-files
 * lesson.
 *
 * Value shape: { apply(payload) → Promise, appliedAt: {[proposalKey]: iso},
 * busy } — null outside a refine drawer (the card then renders read-only).
 */
import { createContext, useContext } from 'react';

export const ChronologyRefineContext = createContext(null);

export function useChronologyRefine() {
  return useContext(ChronologyRefineContext);
}
